var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tag-picker',{attrs:{"space":_vm.space,"exclude":_vm.exclude_ids},on:{"select":_vm.select}},[_c('i',{staticClass:"fas fa-tag"})])}
var staticRenderFns = []

export { render, staticRenderFns }